import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getSupabase } from '../../supabaseFactory';
import type { ShopSettings } from './types';
import { toSupabaseError } from '../../utils/supabaseError';

/**
 * Lädt die 1-Row shop_settings.
 * Genutzt von Public-Page (Hero, Storytelling, Standort) + Admin-Settings.
 */
export function useShopSettings() {
  return useQuery({
    queryKey: ['shop', 'settings'],
    queryFn: async (): Promise<ShopSettings | null> => {
      const sb = getSupabase();
      const { data, error } = await sb
        .from('shop_settings')
        .select('*')
        .eq('id', 1)
        .maybeSingle();
      if (error) throw toSupabaseError(error);
      return data as ShopSettings | null;
    },
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
  });
}

export function useUpdateShopSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (patch: Partial<Omit<ShopSettings, 'id'>>) => {
      const sb = getSupabase();
      const { error } = await sb
        .from('shop_settings')
        .update(patch)
        .eq('id', 1);
      if (error) throw toSupabaseError(error);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['shop', 'settings'] });
    },
  });
}
